import { render, staticRenderFns } from "./cultivos.vue?vue&type=template&id=13170e70&scoped=true&"
import script from "./cultivos.vue?vue&type=script&lang=js&"
export * from "./cultivos.vue?vue&type=script&lang=js&"
import style0 from "./cultivos.vue?vue&type=style&index=0&id=13170e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13170e70",
  null
  
)

export default component.exports